// Utility function for className merging
export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}
